export var flatArray = function (array) {
    return !Array.isArray(array) ? array : [].concat.apply([], array.map(flatArray));
};
